import { defineStore } from "pinia";
import { axiosClient } from "@/helpers/auth";
import { ref } from "vue";

export const useCommentStore = defineStore("commentStore", () => {
  const isCreating = ref(false);
  const isUpdating = ref(false);
  const isDeleting = ref(false);

  async function createComment (payload) {
    isCreating.value = true;
    const response = await axiosClient.post("/comment", payload);
    isCreating.value = false;
    return response;
  }

  async function updateComment (payload) {
    isUpdating.value = true;
    const response = await axiosClient.put("/comment", payload);
    isUpdating.value = false;
    return response;
  }

  async function deleteComment (payload) {
    isDeleting.value = true;
    const response = await axiosClient.delete("/comment", { data: payload });
    isDeleting.value = false;
    return response;
  }

  return {
    isCreating,
    isUpdating,
    isDeleting,
    createComment,
    updateComment,
    deleteComment
  };
});
